import { billingAddressInitialValues } from "../../../../components/BillingAddressFormBlock";

export const notSureReasonValue = 585;

export const aboutYouInitialFormValues = {
  experience: "",
  cdCV: "",
  linkURL: [],
  castingForUnder18: "",
  castingForUnder18Aware: "",
  usingFor: "",
  aboutYou: "",
  ...billingAddressInitialValues,
};
